import { DEFAULT_LOCALE } from '@/constants/defaultLocale'

/**
 * 站內路徑補上語系前綴（/terms/user-terms → /zh-tw/terms/user-terms）。
 * 給 <a href> 用：next/link 與 router.push 會自己帶語系，原生連結不會，沒帶就會被 middleware 依瀏覽器語言導走。
 * 外部網址（http…）原樣回傳。
 */
const localizePath = (url: string, locale?: string) => {
  if (!url.startsWith('/')) return url
  const lang = !locale || locale === 'default' ? DEFAULT_LOCALE : locale
  return `/${lang}${url}`
}

export default localizePath
